import React from "react";
import { Select } from "../../../../../../shared/infrastructure/ui";
import { SelectComponentProps } from "./types";
import { useInfiniteGetLocations } from "../../../services";
import { withSelectOptions } from "./with-select-options";
import { LocationT, UseGetLocationsFilters } from "../../../../domain/entities";

const RenderOption = ({
  city,
  state_id,
  state_code,
  market,
}: LocationT): React.ReactElement => {
  return (
    <section className="grid w-[300px] grid-flow-col items-center justify-between px-[5px] text-[12px]">
      <span>
        {city}, {state_code ?? state_id}
      </span>
      <span className="rounded-[5px] bg-[#F4F4F4] py-[5px] px-[10px] text-[10px]">
        {market ?? "- -"}
      </span>
    </section>
  );
};

const LocationSelectComponent = ({
  placeholder,
  name = "",
  selectedValue,
  onChangeValue,
  error = "",
  variant = "standard",
  disabled = false,
  handleSetKeyword,
  isLoading,
  getNextPage,
  noMore,
  data,
  noError,
  labelProp = "city",
  keyword,
  multiselect,
  required,
}: SelectComponentProps<LocationT>): React.ReactElement => {
  return (
    <Select<LocationT>
      searchValue={keyword}
      multiselect={multiselect}
      disabled={disabled}
      loading={isLoading}
      placeholder={placeholder}
      options={data}
      name={name}
      asyncFilter={handleSetKeyword}
      labelProp={labelProp}
      label={(option) =>
        `${option.city}, ${option.state_id ?? option.state_code}`
      }
      value={selectedValue}
      onChange={onChangeValue}
      noMore={noMore}
      getMore={getNextPage}
      renderOptionComponent={RenderOption}
      error={error}
      variant={variant}
      noError={noError}
      required={required}
    />
  );
};

export const LocationSelect = withSelectOptions<
  LocationT,
  UseGetLocationsFilters
>(LocationSelectComponent, useInfiniteGetLocations, "location");
